import { useCallback, useState } from "react";
import LayoutPage from "../../Components/LayoutPage";
import DefinitionTab from "./Components/DefinitionTab";
import InsightsTab from "./Components/InsightsTab";
import PayoutTab from "./Components/PayoutTab";
import { API_BASE_URL } from "../../config/api";

const REFRESH_ENDPOINT = `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`;

const TABS = [
  { key: "definition", label: "تعریف" },
  { key: "insights", label: "بینش" },
  { key: "payout", label: "برداشت" },
];

export default function SalesParticipation() {
  const [activeTab, setActiveTab] = useState("definition");

  const logout = useCallback(() => {
    localStorage.removeItem("access");
    localStorage.removeItem("authCredentials");
    localStorage.removeItem("refresh");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    window.location.href = "/signin";
  }, []);

  const authFetch = useCallback(
    async (url, options = {}) => {
      const headers = new Headers(options.headers || {});
      if (!(options.body instanceof FormData) && !headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
      }
      headers.set("Authorization", `Bearer ${localStorage.getItem("access")}`);

      let response = await fetch(url, {
        ...options,
        headers,
      });

      if (response.status !== 401) return response;

      const refreshResponse = await fetch(REFRESH_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          refresh: localStorage.getItem("refresh"),
        }),
      });

      if (!refreshResponse.ok) {
        logout();
        return null;
      }

      const refreshData = await refreshResponse.json();
      localStorage.setItem("access", refreshData.access);

      const retryHeaders = new Headers(options.headers || {});
      if (
        !(options.body instanceof FormData) &&
        !retryHeaders.has("Content-Type")
      ) {
        retryHeaders.set("Content-Type", "application/json");
      }
      retryHeaders.set(
        "Authorization",
        `Bearer ${localStorage.getItem("access")}`,
      );

      response = await fetch(url, {
        ...options,
        headers: retryHeaders,
      });

      return response;
    },
    [logout],
  );

  return (
    <LayoutPage
      activeIndex={18}
      navItems={["همکاری در فروش"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-2.5"
    >
      <div className="w-full p-1 rounded-lg border border-zi-border-light dark:border-zi-border-dark bg-zi-bg1-light dark:bg-zi-bg1-dark flex items-center gap-1">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={`flex-1 rounded-md py-2 text-sm ${
              activeTab === tab.key
                ? "bg-zi-bg2-light dark:bg-zi-bg2-dark text-zi-blue-light"
                : "text-zi-text-light/60 dark:text-zi-text-dark/60"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="flex-1 min-h-0 overflow-auto">
        {activeTab === "definition" && <DefinitionTab authFetch={authFetch} />}
        {activeTab === "insights" && <InsightsTab authFetch={authFetch} />}
        {activeTab === "payout" && <PayoutTab authFetch={authFetch} />}
      </div>
    </LayoutPage>
  );
}
